var _react_refresh_temp_1;
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
const Avatar = ({ participant, from }) => {
    const render = () => {
        var _a;
        if ((_a = participant === null || participant === void 0 ? void 0 : participant.metadata) === null || _a === void 0 ? void 0 : _a.profile_pic) {
            return (_jsx("img", { src: participant === null || participant === void 0 ? void 0 : participant.metadata.profile_pic, alt: participant.name }));
        }
        else {
            let name = from.name;
            if (participant === null || participant === void 0 ? void 0 : participant.name) {
                name = participant === null || participant === void 0 ? void 0 : participant.name;
            }
            return _jsx(_Fragment, { children: name === null || name === void 0 ? void 0 : name.slice(0, 2).toUpperCase() });
        }
    };
    return (_jsx("div", { className: "avatar flex items-center justify-center text-white h-8 w-8 overflow-hidden rounded-full shadow-header bg-primaryColor", children: render() }));
};
_react_refresh_temp_1 = Avatar;
$RefreshReg$(_react_refresh_temp_1, "Avatar");
export default Avatar;
